import React from "react";
import { useSpring, animated, useTransition } from "react-spring";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useDispatch } from "react-redux";
import { setRoute } from "../../store/globalSlice";
import { useNavigate } from "react-router-dom";

function MenuItem(propsComp) {
  const {
    text,
    setActive,
    value,
    logo,
    isActive,
    color,
    backgroundColor,
    width,
  } = propsComp;
  const transitions = useTransition(isActive, null, {
    from: { opacity: 0, width: 0 },
    enter: { opacity: 1, width: width },
    leave: { opacity: 0, width: 0 },
  });
  const matches = useMediaQuery("(min-width:400px)");
  const { x } = useSpring({
    x: isActive ? 1 : 0,
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onClick = () => {
    dispatch(setRoute(value));
    setActive(value);
    navigate(`/${value}`);
  };

  return (
    <animated.div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "14px 5px 14px 5px",
        cursor: "pointer",
        padding: matches
          ? "10px 20px"
          : transitions[0]?.item
          ? "10px 10px"
          : "10px 0px",
        backgroundColor: x.interpolate({
          range: [0, 1],
          output: ["transparent", backgroundColor],
        }),
        borderRadius: 8,
      }}
      onClick={onClick}
    >
      <div style={{ display: "flex", marginLeft: "5px" }}>{logo}</div>
      {transitions.map(({ item, key, props }) => {
        return (
          <>
            {item ? (
              <animated.div
                key={key}
                style={{
                  ...props,
                  fontSize: 12,
                  fontWeight: "bold",
                  color: color,
                  whiteSpace: "nowrap",
                }}
              >
                {text}
              </animated.div>
            ) : (
              ""
            )}
          </>
        );
      })}
    </animated.div>
  );
}

export default MenuItem;
